var updateFacetCounts = function(returnData) {
    // console.log(returnData)
    var facetCounts = returnData;
    $(".facet").find("li").hide();
    $(".facet-item").hide();
    $(".top-facet-column").hide();
    $(".leaffacet").parents(".facet-item");
    if (facetCounts != undefined && facetCounts.length > 0) {
        $(facetCounts.split("|")).each(function() {
            var facetId = String(this.split(":")[0]);
            var facetNum = String(this.split(":")[1]);
            var facetCountSpan = $("#facet_count" + facetId);

            if (facetCountSpan.length > 0 && facetNum > 0) {
                facetCountSpan.html(facetNum).parents("li").show().parents(".facet-item").show();
                if (facetCountSpan.parents(".top-facet-column").length > 0) facetCountSpan.parents(".top-facet-column").show();
            }
        });
    }
    $(".category-nav-facet").show();
    $(".contentRecommendationWidget").find(".facet li").not($("#top-facets-desktop-wrapper").find(".facet li")).show();
    $(".contentRecommendationWidget").find(".facet-item").not($("#top-facets-desktop-wrapper").find(".facet-item")).show();
};

export{updateFacetCounts}
